import Parse from "parse";
window.Parse = Parse
import CCStripe from './stripe'

Parse.initialize("b014fc2c12", "js_key");
Parse.serverURL = "https://backend.chorechampion.com:3306/parse";
const user = Parse.User.current();
const Parent = Parse.Object.extend("Parent");
const Chore = Parse.Object.extend("Chore");
const Reward = Parse.Object.extend('RecommendedRewards')
/**
 * @description Returns the parent belonging to the current user
 * @return {Promise.<Object, error>} A promise that returns a Object if resolved,
 *     or an Error if rejected.
 *  */
export function getParent() {
  return new Promise(async (resolve, reject) => {
    const ParentQuery = new Parse.Query(Parent);
    await ParentQuery.equalTo("user", user);
    const res = await ParentQuery.find().catch(e => {
      reject(2)
    })
    if (res.length == 0) {
      resolve(await createParent())
    } else { resolve(res[0]); }
  });
}

/**
 * @description Makes a new parent
 * @return {Promise.<Object, error>} A promise that returns a Object if resolved,
 *     or an Error if rejected.
 *  */
export async function createParent() {
  return new Promise(async resolve => {
    const parent = new Parent();
    await parent.set("user", user);
    await parent.set("slimView", true)
    await parent.save();
    await CCStripe.newCustomer(parent);
    resolve(parent);
  });
}


/**
 * @description Logout
 */
export function logout() {
  Parse.User.logOut().then(x => {
    VueInstance.$root.$data = VueInstance.originalValue()
    setTimeout(() => location.reload(true), 500)
    location.href = "/#/"
  })
}

export async function addChore(kid, choreData) {
  const chore = new Chore()
  const permissions = new Parse.ACL(user);
  permissions.setReadAccess(user, true)
  permissions.setWriteAccess(user, true)
  await chore.setACL(permissions);
  await editChore(kid, chore, choreData)
  gtag('event', 'add_chore', {
    'name': choreData.name,
    'points': choreData.points,
    'repeats': choreData.repeats
  });
}
export async function editChore(kid, chore, choreData) {
  let image, titleIncludes = x => choreData.title.toLowerCase().includes(x);
  chore.set("name", choreData.title)
  chore.set('points', Number(choreData.points))
  chore.set('done', choreData.done)
  chore.set('Child', kid)
  chore.set('repeats', choreData.repeats)
  chore.set('photoVerify', false)
  if (titleIncludes('brush teeth')) image = "/images/chores/brushTeeth.jpg"
  else if (titleIncludes('clean') || titleIncludes('kitchen')) image = "/images/chores/kitchen.jpeg"
  else if (titleIncludes('empty dish')) image = "/images/chores/empty_dishwasher.jpeg"
  else if (titleIncludes('dishes') || titleIncludes('plato') || titleIncludes('traste') || titleIncludes('vajilla')) image = "/images/chores/dishes.jpeg"
  else if (titleIncludes('rake') || titleIncludes('rastrillar')) image = "/images/chores/rake.jpeg"
  else if (titleIncludes('weed')) image = "/images/chores/weed.jpeg"
  else if (titleIncludes('lawn') || titleIncludes('grass') || titleIncludes('mow') || titleIncludes('césped')) image = "/images/chores/mow.jpg"
  else if (titleIncludes('sweep')) image = "/images/chores/sweep.jpg"
  else if (titleIncludes('dust')) image = "/images/chores/dust.jpg"
  else if (titleIncludes('trash') || titleIncludes('rubbish') || titleIncludes('garbage')) image = "/images/chores/trash.jpg"
  else if (titleIncludes('cook') || titleIncludes('bake') || titleIncludes('dinner')) image = "/images/chores/bake.jpg"
  else if (titleIncludes('shower') || titleIncludes('bathe') || titleIncludes('take a bath')) image = "/images/chores/shower.jpeg"
  else if (titleIncludes('medicine') || titleIncludes('take meds')) image = '/images/chores/meds.jpeg'
  else if (titleIncludes('scripture') || titleIncludes('praise') || titleIncludes('bible study') || titleIncludes('worship')) image = '/images/chores/praise.jpeg'
  else if ((titleIncludes('read') && !titleIncludes('ready')) || titleIncludes('book')) image = '/images/chores/reading.jpg'
  else if (titleIncludes('vacuum')) image = '/images/chores/vacuum.jpg'
  else if (titleIncludes('laundry')) image = '/images/chores/laundry.jpg'
  else if (titleIncludes('cat')) image = '/images/chores/cat.jpg'
  else if (titleIncludes('litter')) image = '/images/chores/litter.jpg'
  else if (titleIncludes('bathroom')) image = '/images/chores/bathroom.jpg'
  else if (titleIncludes('bedroom') || titleIncludes('make bed') || titleIncludes('tidy room')) image = '/images/chores/tidy-bedroom.jpg'



  chore.set('image', image)
  await chore.save();
  await kid.relation('chores').add(chore)
  await kid.save()
}

export function addChild(_t) {
  return new Promise(async (resolve, reject) => {
    const kid = new (await Parse.Object.extend("Kid"))();
    const permissions = new Parse.ACL(user);
    permissions.setReadAccess(user, true)
    permissions.setWriteAccess(user, true)
    await kid.setACL(permissions);
    kid.set("name", _t.$data.name.replace(/[^\w ]/, '').trim());
    kid.set('age', Math.floor(_t.$data.age))
    kid.set('points', 0)
    kid.set('parent', _t.$root.$data.parent)
    await kid.save().then(async () => {
      gtag('event', 'add_child');
      resolve(true)
    })
  })
}

export function buyPremium() {

}

export function addChildViaLinkCode(linkCode) {
  return new Promise(async (resolve, reject) => {
    const LinkableDevice = Parse.Object.extend("LinkableDevice");
    let devices = new Parse.Query(LinkableDevice)
    devices.get(linkCode).then(async child => {
      const kid = new (await Parse.Object.extend("Kid"))();
      const permissions = new Parse.ACL(user);
      permissions.setReadAccess(user, true)
      permissions.setWriteAccess(user, true)
      await kid.setACL(permissions);
      kid.set("name", child.get('childName'));
      //  kid.set("image", _t.$data.image);
      kid.set('age', Number(child.get('childAge')))
      kid.set('points', 0)
      kid.set('parent', VueInstance.$data.parent)
      let confirmAdding = await ModernModals.prompt(`Would you like to add ${child.get('childName')} to your account?`)
      if (confirmAdding) {
        await kid.save().then(async () => {
          await confirmLinking(linkCode)
          VueInstance.$root.initLoadChores()
          window.location = '/#/parents'
        })
      } else {
        ModernModals.alert('Adding child has been cancelled.')
      }
    })
  })
}

export function confirmLinking(id) {
  return new Promise((resolve, reject) => {
    const LinkableDevice = Parse.Object.extend("LinkableDevice");
    let devices = new Parse.Query(LinkableDevice)
    devices.get(id).then(async device => {
      if (!user.get('passwd')) {
        let pass = prompt('Please confirm password to link devices!')
        await user.set('passwd', pass)
        await user.save(

        )
      }
      await device.set('username', user.get('email'))
      await device.set('password', user.get('passwd'))
      await device.save().then(x => {
        resolve(x)
      })
    })
  })
}

/**
 * @description Gets rewards
 * @param {Object} loc
 * @param {Number} loc.longitude Longitude
 * @param {Number} loc.latitude
 * @param {Number} radius Radius to search in
 * @return {Promise.<Array, error>} A promise that returns a Array containing all rewards within {radius} of {latitude} and {longitude}
 *  */
export function getRewards() {
  return new Promise((resolve, reject) => {
    let allRewards = []
    let RewardQuery = new Parse.Query(Reward);
    RewardQuery.find().then(rewards => {
      rewards.forEach(reward => {
        allRewards.push(reward)
      })
    })
    resolve(allRewards)
  })
}
export function createLinkableDevice(name, age) {
  const LinkableDevice = Parse.Object.extend("LinkableDevice");
  return new Promise(async (resolve, rej) => {
    let device = new LinkableDevice()
    await device.set('hasBeenLinked', false)
    await device.set('childName', name)
    await device.set('childAge', age)
    device.save().then(device => {
      window.localStorage.setItem('deviceKey', device.id);
      var QRCode = require("qrcode-svg");
      var svg = new QRCode({
        padding: 0, height: 200, width: 200, content: `${device.id}`, container: "svg-viewbox", background: 'transparent', color: (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'white' : 'black'
      }).svg();
      resolve({ svg: svg, id: device.id })
    })
  })
}

export function loginViaLink() {
  return new Promise((resolve, reject) => {
    const LinkableDevice = Parse.Object.extend("LinkableDevice");
    let devices = new Parse.Query(LinkableDevice)
    devices.get(window.localStorage.getItem('deviceKey')).then((device) => {
      console.log(device.toJSON())
      if (device.get('username') && device.get('password')) {
        resolve({ username: device.get('username'), password: device.get('password') })
      }
    }, (error) => {
      reject()
      // The object was not retrieved successfully.
      // error is a Parse.Error with an error code and message.
    });
  });
}
/**
 * @description Returns the parent belonging to the current user
 * @return {Promise.<Object, error>} A promise that returns a Object if resolved,
 *     or an Error if rejected.
 *  */
export function setUserPatreonToken(code, token) {
  return new Promise(async (resolve, reject) => {
    let parent = await getParent();
    parent.set('patreonAuthCode', code)
    parent.set('patreonAuthToken', token)
  });
}
